/*
 * Copyright 2026 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/kmp-project-template/blob/main/LICENSE
 */
package kpt.core.base.network

import org.koin.core.scope.Scope

/** A browser bundle carries no build-type signal, so web always takes the release logging policy. */
actual fun Scope.isDebugBuild(): Boolean = false
